// extracted by mini-css-extract-plugin
module.exports = {"sign-up-switch__container":"SignUpSwitch_sign-up-switch__container__iUzvu"};